import { GetProjectsSearchParams } from 'src/shared/api/projects/types';

export const parseProjectsSearchQuery = (input: string): GetProjectsSearchParams => {
  const normalized = input.trim();
  if (!normalized) {
    return {};
  }

  const query: GetProjectsSearchParams = {};
  const freeText: string[] = [];
  const appendListFilterValue = (
    key: 'cube' | 'workflow_status' | 'dimension',
    rawValue: string,
  ) => {
    const normalizedValue = rawValue.trim();
    if (!normalizedValue) {
      return;
    }

    const currentValue = query[key];
    if (!currentValue) {
      query[key] = normalizedValue;
      return;
    }

    const values = currentValue
      .split(',')
      .map(item => item.trim().toLowerCase())
      .filter(Boolean);

    if (values.includes(normalizedValue.toLowerCase())) {
      return;
    }

    query[key] = `${currentValue},${normalizedValue}`;
  };

  normalized.split(/\s+/).forEach(part => {
    const token = part.trim();
    if (!token) {
      return;
    }

    const lowerToken = token.toLowerCase();
    if (lowerToken.startsWith('field:')) {
      query.field_name = token.slice(6).trim();
      return;
    }

    if (lowerToken.startsWith('content:')) {
      query.content = token.slice(8).trim();
      return;
    }

    if (lowerToken.startsWith('cube:')) {
      appendListFilterValue('cube', token.slice(5));
      return;
    }

    if (lowerToken.startsWith('status:')) {
      appendListFilterValue('workflow_status', token.slice(7));
      return;
    }

    if (lowerToken.startsWith('dimension:')) {
      appendListFilterValue('dimension', token.slice(10));
      return;
    }

    if (lowerToken.startsWith('dim:')) {
      appendListFilterValue('dimension', token.slice(4));
      return;
    }

    if (lowerToken.startsWith('attr:')) {
      query.field_name = token.slice(5).trim();
      return;
    }

    const createdMatch = token.match(/^created(>=|<=|=|>|<)(\d{4}-\d{2}-\d{2})$/i);
    if (createdMatch) {
      const [, op, date] = createdMatch;
      if (op === '>' || op === '>=') {
        query.created_from = date;
      } else if (op === '<' || op === '<=') {
        query.created_to = date;
      } else {
        query.created_from = date;
        query.created_to = date;
      }
      return;
    }

    const updatedMatch = token.match(/^updated(>=|<=|=|>|<)(\d{4}-\d{2}-\d{2})$/i);
    if (updatedMatch) {
      const [, op, date] = updatedMatch;
      if (op === '>' || op === '>=') {
        query.updated_from = date;
      } else if (op === '<' || op === '<=') {
        query.updated_to = date;
      } else {
        query.updated_from = date;
        query.updated_to = date;
      }
      return;
    }

    freeText.push(token);
  });

  if (freeText.length) {
    query.search = freeText.join(' ');
  }

  return query;
};
